import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { IndicatorStandards } from 'types/lcms/courses';
import { InputInformation } from './InputInformation';
import { useQuery } from '@tanstack/react-query';
import { courseService } from 'services/lcms/course.service';

interface IndicatorStandarsSectionProps {
  data?: IndicatorStandards;
}

const IndicatorStandarsSection: React.FC<IndicatorStandarsSectionProps> = ({ data }) => {
  const { data: dataPassingFormula, isPending } = useQuery({
    queryKey: ['getPassingFormula'],
    queryFn: () =>
      courseService.getPassingFormula({
        pageSize: 1000,
        pageNumber: 1
      }),
    staleTime: Infinity
  });

  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Indicator & Standards
          </Text>
        </Group>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            LIM Indicator
          </Text>
          <Text fz={14} c={'dark'}>
            {data?.limIndicator ? 'Yes' : 'No'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            LIA Indicator
          </Text>
          <Text fz={14} c={'dark'}>
            {data?.liaIndicator ? 'Yes' : 'No'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Group gap={0}>
            <Text c={'grey.5'} fw={600} fz={14}>
              Bloom`s Taxonomy
            </Text>
            <InputInformation description='Bloom`s Taxonomy Measurement Level' />
          </Group>
          <Text fz={14} c={'dark'}>
            {data?.c || '-'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Passing Formula
          </Text>
          <Text fz={14} c={'dark'}>
            {!isPending && data?.passingFormula ? (
              <Group align='center' gap={0}>
                <Text fz={14} c={'dark'}>
                  Formula {data.passingFormula}
                </Text>
                <InputInformation
                  description={
                    dataPassingFormula?.data?.find(
                      (formula: { option: string }) => formula.option === data.passingFormula
                    )?.optionDesc as string
                  }
                />
              </Group>
            ) : (
              '-'
            )}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};

export default IndicatorStandarsSection;
